
( function($){
    //// QUICK EXIT
    function getAway() {
        // Get away right now
        // window.open("http://weather.com", "_newtab");
        // // Replace current site with another benign site
        // window.location.replace('http://www.bom.gov.au/?ref=logo');
        window.open("https://google.com", '_self').window.close();
    }
    $(".get-away").on("click", function(e) {
        getAway();
    });


    $('#hamburger-menu, .closebtn, .nav-mobile-overlay').click(function () {
        $(".mobile-nav").toggleClass('open');
    });


} (jQuery) );